import { Maybe } from "@/types"
import { parseJSON } from "@/utils/json"
import { createInMemoryStorage } from "./createInMemoryStorage"
import logger from "./logger"

type ValidKey = `nosto:${string}`

interface Store {
  get(key: ValidKey): string | null
  set(key: ValidKey, value: string): void
  remove(key: ValidKey): void
  getAsJson<T>(key: ValidKey): Maybe<T>
  setAsJson<T>(key: ValidKey, value: T): void
}

function storeFromStorage(storage: Storage): Store {
  return {
    get(key: ValidKey) {
      return storage.getItem(key)
    },
    set(key: ValidKey, value: string) {
      storage.setItem(key, value)
    },
    remove(key: ValidKey) {
      storage.removeItem(key)
    },
    getAsJson<T>(key: ValidKey) {
      const value = storage.getItem(key)
      return parseJSON<T>(value)
    },
    setAsJson<T>(key: ValidKey, value: T) {
      storage.setItem(key, JSON.stringify(value))
    }
  }
}

let localStore: Store
let sessionStore: Store

/**
 * Touching `localStorage` or `sessionStorage` may throw if disabled by browser settings
 */
try {
  localStore = storeFromStorage(localStorage)
  sessionStore = storeFromStorage(sessionStorage)
} catch (e) {
  logger.warn("Either localStorage or sessionStorage is not available. Storage will not be persistent.", e)
  localStore = storeFromStorage(createInMemoryStorage())
  sessionStore = storeFromStorage(createInMemoryStorage())
}

export { localStore, sessionStore }
